import React from 'react'
import PropTypes from 'prop-types'
import { EditEventForm } from 'local/components'

const EventAddComponent = ({ onSubmit }) => (
  <EditEventForm header="Add Event" onSubmit={onSubmit} />
)

EventAddComponent.propTypes = {
  onSubmit: PropTypes.func.isRequired,
}

export default EventAddComponent
